// frontend/src/utils/medicalHistoryDiagnoses.js

const medicalHistoryDiagnoses = {
  neurological: [ // Updated with Vietnamese list
    'Chronic headache',
    'Hearing loss',
    'Visual impairment',
    'Seizures (epilepsy)',
    'Memory impairment',
    'Cerebral ischemia (stroke)',
    'Brain injury',
    'Major depression (affecting daily life)',
    'Severe anxiety (impacting daily life)',
    'Bipolar disorder',
    'Schizophrenia'
    // Add more as needed (if applicable)
  ],
  cardiovascular: [ // Updated with Vietnamese list
    'Hypertension (High blood pressure)',
    'Heart attack',
    'Heart failure',
    'Valvular insufficiency',
    'Cardiac arrhythmia',
    'Congenital heart disease',
    'Peripheral ischemia',
    'Anemia - blood loss',
    'Blood clotting disorders',
    'Bleeding disorders (prolonged bleeding)'
    // Add more as needed
  ],
  respiratory: [ // Updated with Vietnamese list
    'Asthma',
    'Chronic obstructive pulmonary disease (COPD)',
    'Obstructive sleep apnea',
    'Recurrent pneumonia',
    'Severe rhinitis (causing breathing difficulty)'
    // Add more as needed
  ],
  metabolic: [ // Renamed from gastrointestinal, contains Vietnamese list
    'Obesity',
    'Type 1 diabetes',
    'Type 2 diabetes',
    'Hyperlipidemia', // Hyperlipidemia
    'Hypothyroidism', // Hypothyroidism
    'Hyperthyroidism', // Hyperthyroidism
    'Gastroesophageal reflux disease (GERD)', // GERD
    'Gastritis', // Gastritis
    'Inflammatory bowel disease (IBD)', // Enteritis/Colitis/IBD?
    'Viral hepatitis', // Viral Hepatitis
    'Cirrhosis', // Cirrhosis
    'Fatty liver disease', // Fatty Liver Disease
    'Gallstones' // Gallstones
    // Add more as needed
  ],
  renal: [ // Updated with Vietnamese list
    'Chronic Kidney Failure',
    'Chronic Kidney Failure Requiring Dialysis',
    'Kidney Stones',
    'Bladder Stones',
    'Recurrent Urinary Tract Infections'
    // Add more as needed
  ],
  musculoskeletal: [ // Updated with Vietnamese list
    'Dentomaxillofacial inflammation',
    'Knee osteoarthritis',
    'Hip osteoarthritis',
    'Spinal osteoarthritis',
    'Leg numbness',
    'Frequent falls - leg weakness',
    'Osteoporosis'
    // Add more as needed
  ],
  immune: [ // Updated with Vietnamese list
    'Autoimmune disease (rheumatoid arthritis, lupus, multiple sclerosis)',
    'Dermatitis',
    'Environmental allergy (drugs, materials, air)',
    'Anaphylactic allergy (difficulty breathing, shock, hypotension, fainting)',
    'HIV', // Keeping both HIV and HIV/AIDS as provided
    'HIV/AIDS',
    'Tuberculosis (TB)', // Tuberculosis (also sometimes Respiratory)
    'Viral hepatitis B or C' // Viral Hepatitis B or C (also Metabolic/GI)
    // Add more as needed
  ],
  womensHealth: [ // Updated with Vietnamese list
    'Menstrual cycle lasting more than 7 days',
    'Menstruation before age 12',
    'Menstruation after age 15',
    'Menopause before age 48',
    'Menopause after age 52',
    'Currently taking oral contraceptives',
    'History of oral contraceptive use for more than 5 years',
    'Polycystic ovary syndrome (PCOS)',
    'Gestational diabetes',
    'Gestational hypertension',
    'Gestational heart failure',
    'Seizures during pregnancy (eclampsia)',
    'Abnormal Pap smear',
    'Abnormal mammogram'
    // Add more as needed
  ],
  mensHealth: [ // Updated with Vietnamese list
    'Prostate disorder',
    'Physiological disorder',
    'Testosterone deficiency'
    // Add more as needed
  ],
  cancer: [ // Added new Cancer section with Vietnamese list
    'Brain',
    'Oral cavity and throat cancer',
    'Thyroid gland',
    'Lung',
    'Stomach',
    'Liver',
    'Gallbladder',
    'Colon cancer',
    'Kidney',
    'Bladder',
    'Skin cancer',
    'Bone cancer',
    'Mammary gland',
    'Blood cancer',
    'Prostate cancer (male)',
    'Testicular cancer (male)',
    'Uterine cancer (female)',
    'Ovarian cancer (female)'
    // Add more as needed
  ],
  // Removed redundant Endocrine category as items merged into Metabolic
  // Consider adding other categories like:
  // dermatological: [ 'Eczema', 'Acne', 'Skin Cancer History', ... ]
  // hematological: [ 'Anemia', 'Bleeding Disorder', 'Clotting Disorder', ... ] // Note: Some hematologic terms were in Vietnamese Cardio list
  // psychiatric: [ 'Depression', 'Anxiety', 'Bipolar Disorder', 'Schizophrenia', ... ] // Note: Some psychiatric terms were included in the Vietnamese Neuro list
  other: [
    // Allow for manual entry or less common items
  ]
};

export default medicalHistoryDiagnoses;
